import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';

export interface NotificationData {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
  duration?: number;
  showClose?: boolean;
}

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      state('out', style({
        transform: 'translateX(100%)',
        opacity: 0
      })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class NotificationComponent implements OnInit, OnDestroy {
  @Input() notification!: NotificationData;
  @Output() close = new EventEmitter<string>();

  isVisible = true;
  private timeoutId?: number;

  progressWidth = 100;

  ngOnInit(): void {
    if (this.notification.duration && this.notification.duration > 0) {
      // Animar la barra de progreso
      const startTime = Date.now();
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(0, 100 - (elapsed / this.notification.duration! * 100));
        this.progressWidth = remaining;
        
        if (remaining > 0) {
          requestAnimationFrame(animate);
        }
      };
      animate();

      this.timeoutId = window.setTimeout(() => {
        this.closeNotification();
      }, this.notification.duration);
    }
  }

  ngOnDestroy(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  getTypeClass(): string {
    return `notification-${this.notification.type}`;
  }

  getIconClass(): string {
    const icons = {
      success: 'pi pi-check',
      error: 'pi pi-times',
      warning: 'pi pi-exclamation-triangle',
      info: 'pi pi-info-circle'
    };
    return icons[this.notification.type];
  }

  closeNotification(): void {
    this.isVisible = false;
    setTimeout(() => {
      this.close.emit(this.notification.id);
    }, 300);
  }
}